import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import ResourceList from 'components/list/Container/ResourceList';
import { deleteAccountUsers } from 'store/actions/accounts/users/deleteAccountUsers';
import { fetchAccountUsers } from 'store/actions/accounts/users/fetchAccountUsers';
import authHelper from 'helpers/auth';

class RelatedUserList extends Component {
    render() {
        const {
            resource,
        } = this.props;

        const isOwner = authHelper.isOwner();

        return (
            <ResourceList
                action={ fetchAccountUsers }
                actionType={ 'ACCOUNT_USERS' }
                hidePagination={ true }
                location={ location }
                resource={ resource }
            >
                <Table
                    colorToggle={ {
                        condition: false,
                        color: 'gray',
                        key: 'is_enabled',
                    } }
                >
                    <TextField
                        column={ {
                            sortable: false,
                            width: '33%',
                            link: false,
                        } }
                        label={ 'resources.users.fields.lastname' }
                        maxCharacters={ 100 }
                        source='last_name'
                    />
                    <TextField
                        column={ {
                            sortable: false,
                            width: '33%',
                            link: false,
                        } }
                        label={ 'resources.users.fields.firstname' }
                        maxCharacters={ 100 }
                        source='first_name'
                    />
                    <TextField
                        column={ {
                            sortable: false,
                            width: '33%',
                            link: false,
                        } }
                        label={ 'resources.users.fields.email' }
                        maxCharacters={ 100 }
                        source='email'
                    />
                    { isOwner &&
                        <DropDownActionsMenu
                            column={ {
                                align: 'center',
                                link: false,
                                width: '10%',
                            } }
                            resource={ resource }
                        >
                            <DeleteAction action={ deleteAccountUsers } />
                        </DropDownActionsMenu>
                    }

                </Table>
            </ResourceList>
        );
    }
}

RelatedUserList.propTypes = {
    resource: PropTypes.string.isRequired,
};

export default RelatedUserList;


// WEBPACK FOOTER //
// ./src/pages/invitations/list/related-users/RelatedUserList.js